import { render, staticRenderFns } from "./SearchControllerSettings.vue?vue&type=template&id=2ed9f5de&"
import script from "./SearchControllerSettings.vue?vue&type=script&lang=js&"
export * from "./SearchControllerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports